<template>
  <ion-icon :icon="icon" :color="color" aria-hidden="true"></ion-icon>
</template>

<script>
import { IonIcon } from '@ionic/vue';
import { bookmark, bookmarkOutline } from 'ionicons/icons';
import { store } from '@/store';

export default  {
  name: 'BookmarkIcon',
  components: { IonIcon },
  setup() {
    return {
      bookmark,
      bookmarkOutline
    }
  },
  data() {
    return {
      sharedState: store.state,
      color: 'primary',
      icon: bookmarkOutline,
    }
  },
  methods: {
    checkIfBookmarksMatch: async function() {
      const bookmarks = await store.getBookmarks();
      this.icon = bookmarkOutline;
      this.color = 'primary';
      if (!bookmarks || !bookmarks.bookmarks) return;
      const lang = await store.getLanguage();
      bookmarks.bookmarks.forEach(group => {
        if (!group || !group.items) return;
        group.items.forEach(item => {
          if (item.url === this.$route.fullPath && item.language === lang) {
            this.color = item.color;
            this.icon = bookmark;
          }
        });
      });
    }
  },
  mounted: async function() {
    this.checkIfBookmarksMatch();
  },
  watch: {
    'sharedState.bookmarks': {
      deep: true,
      handler: async function() { this.checkIfBookmarksMatch() }
    }
  }
}
</script>

